export const setSelectedModule = (module) => ({
  type: "SET_SELECTED_MODULE",
  payload: module,
});
